import getAmountPaid from './getAmountPaid'

export default function getAmountOwed(order) {
  if (order.total === undefined || order.total === null) return 0
  return order.total.toFixed(2) - getAmountPaid(order)
}
